const prefix = 'fac';
const iconName = 'merge-none';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M515 447C515 484.555 484.555 515 447 515H228C190.445 515 160 484.555 160 447L160 228C160 190.445 190.445 160 228 160L447 160C484.555 160 515 190.445 515 228V447Z M68 64V0L287 1.91456e-05V64L68 64ZM64 68L64 287C64 289.209 65.7909 291 68 291L287 291C289.209 291 291 289.209 291 287L291 68C291 65.7909 289.209 64 287 64V1.91456e-05C324.262 2.34259e-05 354.524 29.9708 354.994 67.1211L355 68L355 287C355 324.555 324.555 355 287 355L68 355L67.1211 354.994C29.9708 354.524 -2.23465e-06 324.262 0 287L1.91456e-05 68L0.0058786 67.1211C0.472756 30.2633 30.2633 0.47273 67.1211 0.0058593L68 0V64C65.7909 64 64 65.7909 64 68Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMergeNone };
